import { Workbox } from "workbox-window";
import { ref } from "vue";

// Flag réactif partagé : consommé par Atmo.vue pour afficher la snackbar
// "nouvelle version disponible". On le pose ici (et non dans le composant) pour
// pouvoir attacher le listener "waiting" AVANT register() (voir plus bas).
export const newAppIsAvailable = ref(false);

let workbox;

// Le navigateur ne re-vérifie service-worker.js que lors d'une navigation
// complète (rechargement) ou après ~24h. ATMO étant une SPA souvent laissée
// ouverte sans rechargement, ces déclencheurs n'arrivent quasiment jamais : on
// force donc la vérification nous-mêmes, c'est le pattern recommandé par Workbox.
const PERIODIC_CHECK_INTERVAL_MS = 30 * 60 * 1000; // 30 min
const MIN_CHECK_INTERVAL_MS = 60 * 1000; // throttle anti-rafale (focus/online)

if (import.meta.env.PROD && "serviceWorker" in navigator) {
  workbox = new Workbox(`${import.meta.env.BASE_URL}sw.js`);

  // IMPORTANT : listener attaché AVANT register(). Si un nouveau SW est déjà en
  // "waiting" depuis une session précédente, workbox émet "waiting" pendant
  // register() (wasWaitingBeforeRegister)
  workbox.addEventListener("waiting", () => {
    newAppIsAvailable.value = true;
  });

  // Une fois le nouveau SW activé (après clic "Rafraîchir" -> SKIP_WAITING), il
  // prend le contrôle de la page : on recharge pour servir la nouvelle version.
  workbox.addEventListener("controlling", () => {
    globalThis.location.reload();
  });

  const registerWorkbox = async () => {
    try {
      await workbox.register();
    } catch {
      // Un sw.js retiré par un déploiement fait rejeter register() ; la page
      // reste utilisable sans PWA, on ne laisse pas le rejet remonter.
    }
  };
  registerWorkbox(); // NOSONAR

  let lastCheck = 0;
  const checkForUpdate = () => {
    if (!navigator.onLine) return;
    const now = Date.now();
    if (now - lastCheck < MIN_CHECK_INTERVAL_MS) return;
    lastCheck = now;
    // update() re-télécharge service-worker.js et émettra "waiting" si une
    // nouvelle version est trouvée. Erreur (réseau) ignorée : on réessaiera.
    workbox.update().catch(() => {});
  };

  // Vérification périodique tant que l'onglet vit.
  setInterval(checkForUpdate, PERIODIC_CHECK_INTERVAL_MS);
  // Vérification au retour sur l'onglet (cas le plus fréquent en pratique).
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "visible") checkForUpdate();
  });
  // Vérification au retour de connexion (mode hors-ligne ATMO).
  globalThis.addEventListener("online", checkForUpdate);
} else {
  workbox = null;
}

export default workbox;
